import EventBus from '../../../shared/js/wirebox/event-bus.js'
import jQuery from 'jquery'
import '../../../shared/js/google/modules/maps.js'

class GoogleMapComponent {
    
    /**
     * Construct component
     * @param containers
    */
    constructor(containers) {
        
        /**
         * Map containers
         * @type object
        */
        this.containers = containers
        
        this.bindEvents()
        
    }

    /**
     * Load Google API
    */
    loadGoogleApi() {
        EventBus.publish('load-google-api', this.googleApiLoaded.bind(this))
    }
    
    /**
     * Google API has been loaded
    */
    googleApiLoaded() {
        EventBus.publish('load-google-maps', this.googleMapsLoaded.bind(this))
    }
    
    /**
     * Google Maps API has been loaded
    */
    googleMapsLoaded() {
        
        //Define map style
        const styles = [
            {
                'featureType': 'all',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#48C6D7'
                    }
                ]
            },
            {
                'featureType': 'all',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'gamma': 0.01
                    },
                    {
                        'lightness': 20
                    }
                ]
            },
            {
                'featureType': 'all',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'saturation': -31
                    },
                    {
                        'lightness': -33
                    },
                    {
                        'weight': 2
                    },
                    {
                        'gamma': 0.8
                    }
                ]
            },
            {
                'featureType': 'all',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'landscape',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'lightness': 30
                    },
                    {
                        'saturation': 30
                    }
                ]
            },
            {
                'featureType': 'poi',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'saturation': 20
                    }
                ]
            },
            {
                'featureType': 'poi.park',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'lightness': 20
                    },
                    {
                        'saturation': -20
                    }
                ]
            },
            {
                'featureType': 'road',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'lightness': 10
                    },
                    {
                        'saturation': -30
                    }
                ]
            },
            {
                'featureType': 'road',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'saturation': 25
                    },
                    {
                        'lightness': 25
                    }
                ]
            },
            {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': [
                    {
                        'lightness': -20
                    }
                ]
            }
        ]
        
        let container
        
        //Loop through map containers
        this.containers.each((i, element) => {
            
            container = jQuery(element)
            
            //Construct map
            EventBus.publish('construct-google-map', {
                center: {
                    latitude: container.data('latitude'),
                    longitude: container.data('longitude')
                },
                callback: ({center, map}) => {
                    
                    //Trigger map creation event on element
                    container.trigger('map.created', map)
                    
                },
                element: container.children().first()[0],
                options: {
                    zoom: container.data('zoom'),
                    fullscreenControl: false,
                    styles: styles,
                    minZoom: container.data('min-zoom'),
                    maxZoom: container.data('max-zoom')
                }
            })
            
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('run-modules', this.loadGoogleApi.bind(this))
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const containers = jQuery('.google-map')
    
    if (containers.length > 0) {
        new GoogleMapComponent(containers)
    }
    
})

export default GoogleMapComponent